import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';

export type Severities = 'success' | 'warn' | 'info' | 'error'

@Component({
  selector: 'app-spinner-loading',
  templateUrl: './spinner-loading.component.html',
  styleUrls: ['./spinner-loading.component.css'],
  providers: [MessageService]
})
export class SpinnerLoadingComponent {

  @Input('loading') loading = false
  @Input() mode: 'default' | 'pdf' = 'default';
progress = 0;
particles = Array(12);

simulateProgress() {
  this.progress = 0;

  const interval = setInterval(() => {
    if (this.progress >= 100) {
      clearInterval(interval);
    } else {
      this.progress += Math.random() * 15;
      this.progress = Math.min(100, Math.floor(this.progress));
    }
  }, 300);
}
  constructor(
    private messageService: MessageService
  ) { }

  /**
   * @description Show message
   * @param title Title of the message
   * @param message Body message of the message
   */
  showMessage(title: string, message: string, severities: Severities) {
    this.messageService.add({
      severity: severities,
      summary: title,
      detail: message
    })
  }

}
